<template>
  <com-page>
    <com-card>
      <el-descriptions title="订单信息" :column="4">
        <el-descriptions-item label="订单号">{{ detail.number }}</el-descriptions-item>
        <el-descriptions-item label="小区" v-if="detail.newLogicFlag">{{ detail.residentialAreaName }}</el-descriptions-item>
        <el-descriptions-item label="网点">{{ detail.refStoreName }}</el-descriptions-item>
        <el-descriptions-item label="设备类型">充电桩</el-descriptions-item>
        <el-descriptions-item label="设备号">{{ detail.refDevSn }}</el-descriptions-item>
        <el-descriptions-item label="设备二维码">{{ detail.refDevLabel }}</el-descriptions-item>
        <el-descriptions-item label="充电端口">{{ detail.refDevPort }}</el-descriptions-item>
        <el-descriptions-item label="套餐">
          <div v-if="detail.payPlan && !detail.payPlan.autoStop">
            <div v-if="detail.payPlan.sum">{{ detail.payPlan.sum }}元</div>
            <div v-else>{{ detail.payPlan.duration }}小时</div>
          </div>
          <div v-else>充满自停</div>
        </el-descriptions-item>
        <el-descriptions-item label="订单状态">{{ orderStatus[detail.status] }}</el-descriptions-item>

        <el-descriptions-item label="开始时间">{{ detail.createTime | timeFormate }}</el-descriptions-item>
        <el-descriptions-item label="结束时间">{{ detail.endTime | timeFormate }}</el-descriptions-item>
        <el-descriptions-item label="充电时长">{{ detail.duration }}</el-descriptions-item>
        <el-descriptions-item label="收费区间">
          <template v-if="detail.chargePlanType === 3">
            {{ detail.price || 0 }} 元/度
          </template>
          <template v-else>
            {{ detail.planPowerStart || 0 }}w-{{ detail.planPowerEnd || 0 }}w
            {{ detail.price || 0 }} 元/小时
          </template>
        </el-descriptions-item>
        <el-descriptions-item label="收费标准" v-if="detail.newLogicFlag">
          <el-button type="text" style="padding: 2px 7px" @click="openFeeStandardDialog">查看</el-button>
        </el-descriptions-item>
        <el-descriptions-item label="支付方式">{{ payTypeMap[detail.type] }}</el-descriptions-item>
        <el-descriptions-item label="电费">￥{{ detail.electricCharge || 0 }}</el-descriptions-item>
        <el-descriptions-item label="服务费">￥{{ detail.sum || 0 }}</el-descriptions-item>

        <el-descriptions-item label="订单小计" v-if="detail.newLogicFlag">￥{{ detail.paySum || 0 }}</el-descriptions-item>
        <el-descriptions-item label="实付金额">￥{{ detail.realPaySum }}</el-descriptions-item>
        <el-descriptions-item label="结束原因">{{ detail.errorReason }}</el-descriptions-item>
        <el-descriptions-item label="电量">{{ detail.powerConsumption || 0 }}度</el-descriptions-item>
        <el-descriptions-item label="充电最大功率" v-if="detail.newLogicFlag">{{ detail.power }}w</el-descriptions-item>
        <el-descriptions-item label="充电平均功率" v-if="detail.newLogicFlag">{{ detail.avgPower }}w</el-descriptions-item>
        <el-descriptions-item label="充电功率" v-if="!detail.newLogicFlag">{{ detail.power }}w</el-descriptions-item>
        <el-descriptions-item label="电费成本">{{ detail.cost }}</el-descriptions-item>
        <el-descriptions-item label="利润">￥{{ detail.profit }}</el-descriptions-item>
        <el-descriptions-item label="订单分成" v-if="detail.newLogicFlag">
          <el-button type="text" style="padding: 2px 7px" @click="openOrderDivvyDialog">查看</el-button>
        </el-descriptions-item>
      </el-descriptions>

      <div class="flex items-center justify-between">
        <el-descriptions title="用户信息" :column="1" class="mtb-30px">
          <el-descriptions-item label="用户ID">{{ detail.refUserNumber }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ detail.refUserPhone }}</el-descriptions-item>
        </el-descriptions>

        <el-descriptions title="退单信息" :column="1" v-if="detail.status === '6'">
          <el-descriptions-item label="退单金额">{{ detail.refundSum }}</el-descriptions-item>
          <el-descriptions-item label="退单时间">{{
            detail.refundTime | formatDate
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <el-descriptions title="功率图" :column="1" class="mt-30px"></el-descriptions>
      <div id="chart" ref="myChartRef" style="height: 500px; width: 100%"></div>
    </com-card>

    <fee-standards-dialog ref="feeStandardDialogRef" />
    <order-divvy-dialog ref="orderDivvyDialogRef" type="common-order"/>
  </com-page>
</template>

<script>
import * as echarts from 'echarts'
import utils from 'my-tools-library'
import FeeStandardsDialog from './components/fee-standards-dialog'
import OrderDivvyDialog from './components/order-divvy-dialog'

export default {
  components: { FeeStandardsDialog, OrderDivvyDialog },
  data() {
    return {
      code: '',
      detail: {},
      orderStatus: {
        1: '等待开始',
        2: '进行中',
        3: '已完成',
        4: '异常停止',
        5: '人工关闭',
        6: '退单'
      },
      chargePlanTypeMap: {
        1: '服务费',
        2: '电费+服务费',
        3: '电费+固定服务费',
      },
      payTypeMap: {
        1: '钱包支付',
        2: '套餐支付',
        3: '微信支付'
      }
    }
  },
  created() {
    if (utils.isEmptyObj(this.$route.params)) {
      this.$router.push({ name: 'order-index' })
      return
    }
    this.detail = this.$route.params
  },
  mounted() {
    this.eChartInit()
  },
  methods: {
    eChartInit() {
      const myChart = echarts.init(document.getElementById('chart'))
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['功率']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.detail.date,
          axisLabel: {
            rotate: 45
          }
        },

        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '功率',
            data: this.detail.powers,
            type: 'line'
          }
        ]
      })
      window.onresize = () => {
        // 自适应大小
        myChart.resize()
      }
    },

    openFeeStandardDialog() {
      this.$refs.feeStandardDialogRef.open(this.detail)
    },

    openOrderDivvyDialog() {
      this.$refs.orderDivvyDialogRef.open(this.detail)
    }
  },
}
</script>

<style lang="scss" scoped></style>
